import { useEffect } from 'react';
import documentHtml from './document';
import styles from './styles';

const guide = documentHtml
  .replace('<link rel="stylesheet" href="styles.css">', `<style>${styles}</style>`)
  .replaceAll('href="#', 'href="about:srcdoc#');

export default function PsfaGuide() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'PSFA CDR user guide';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <iframe
      title="PSFA CDR user guide"
      srcDoc={guide}
      sandbox="allow-same-origin allow-popups"
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 0 }}
    />
  );
}
